import { render, staticRenderFns } from "./client_add.vue?vue&type=template&id=97ff8d9a&scoped=true&"
import script from "./client_add.vue?vue&type=script&lang=js&"
export * from "./client_add.vue?vue&type=script&lang=js&"
import style0 from "./client_add.vue?vue&type=style&index=0&id=97ff8d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff8d9a",
  null
  
)

export default component.exports